<app-checkbox-field
  *ngIf="bulkActionControl"
  class="bulk-action-checkbox"
  [hideLabel]="true"
  [fieldId]="bulkActionFieldId"
  [fieldControl]="bulkActionControl"
  (click)="$event.preventDefault()"
>
</app-checkbox-field>

<div class="content-wrapper">
  <div *ngIf="showHeader" class="header-wrapper">
    <span class="header">
      {{ header }}
    </span>

    <app-icon *ngIf="headerIcon" class="header-icon" [icon]="headerIcon">
    </app-icon>
  </div>

  <div *ngIf="description" class="description" [multiLineTruncate]="2">
    {{ description }}
  </div>

  <div *ngIf="subDescription" class="sub-description">
    {{ subDescription }}
  </div>
</div>
